import React from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import useLocalStorage from "react-use-localstorage";
import { AppRoute } from "enums/appRoute";

export const NonAuthorizedRoute = (props: any) => {
  const [token] = useLocalStorage("token");

  const history = useHistory();
  const cardId = history.location.pathname.split("/")[2];

  if (token && cardId)
    return (
      <Redirect
        to={{
          pathname: AppRoute.URLDESIGNER,
        }}
      />
    );

  return <Route {...props} />;
};
